import Reveal from "./Reveal";
import { useBooking } from "../context/BookingContext";

const items = [
  {
    src: "https://customer-assets-gfyr7b9c.emergentagent.net/job_picaso-collections/artifacts/3vxckilt_DSC_0048-2.jpg",
    caption: "The Atelier",
    span: "row-span-2",
    ratio: "aspect-[4/5]",
  },
  {
    src: "https://customer-assets-gfyr7b9c.emergentagent.net/job_picaso-collections/artifacts/qgn3pnpc_picaso.jpeg",
    caption: "Behind the Veil",
    span: "",
    ratio: "aspect-[16/10]",
  },
  {
    src: "https://customer-assets-gfyr7b9c.emergentagent.net/job_picaso-collections/artifacts/rno3r7wl_cathey.webp",
    caption: "Winter Elegance",
    span: "row-span-2",
    ratio: "aspect-[4/5]",
  },
  {
    src: "https://customer-assets-gfyr7b9c.emergentagent.net/job_picaso-collections/artifacts/ff8p0fyx_DSC_0066.jpg",
    caption: "The Davines Ritual",
    span: "",
    ratio: "aspect-[16/10]",
  },
  {
    src: "https://customer-assets-gfyr7b9c.emergentagent.net/job_picaso-collections/artifacts/c91m9e72_wedd.jpeg",
    caption: "Golden Hour",
    span: "",
    ratio: "aspect-[16/10]",
  },
  {
    src: "https://customer-assets-gfyr7b9c.emergentagent.net/job_picaso-collections/artifacts/eecoo8op_wedds.jpeg",
    caption: "The Cascade",
    span: "row-span-2",
    ratio: "aspect-[4/5]",
  },
  {
    src: "https://customer-assets-gfyr7b9c.emergentagent.net/job_picaso-collections/artifacts/s83wcebv_DSC_0070.jpg",
    caption: "Nourishing Essentials",
    span: "",
    ratio: "aspect-[16/10]",
  },
  {
    src: "https://customer-assets-gfyr7b9c.emergentagent.net/job_picaso-collections/artifacts/znco9dk4_wes.jpeg",
    caption: "One Last Look",
    span: "",
    ratio: "aspect-[16/10]",
  },
  {
    src: "https://customer-assets-gfyr7b9c.emergentagent.net/job_picaso-collections/artifacts/lf9ajunm_WhatsApp%20Image%202026-09-17%20at%201.28.49%20PM.jpeg",
    caption: "The Sculpted Updo",
    span: "row-span-2",
    ratio: "aspect-[4/5]",
  },
];

export const Lookbook = () => {
  const { openBooking } = useBooking();

  return (
    <section
      id="lookbook"
      data-testid="lookbook-section"
      className="py-32 md:py-40 max-w-7xl mx-auto px-6 md:px-12"
    >
      <Reveal className="max-w-2xl mb-16 md:mb-24">
        <p className="text-umber text-xs uppercase tracking-[0.3em] mb-5">Bridal Lookbook</p>
        <h2 className="font-serif font-light text-4xl md:text-6xl leading-[1.05] text-obsidian">
          Moments, immortalised
        </h2>
        <p className="mt-6 text-obsidian/70 font-light text-sm md:text-base leading-[1.6]">
          A curated gallery of our signature bridal transformations — each a study in
          restraint, texture, and quiet glamour.
        </p>
      </Reveal>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-7 md:auto-rows-[260px] md:grid-flow-dense">
        {items.map((it, i) => (
          <Reveal
            key={it.caption}
            delay={(i % 3) * 0.08}
            className={`group relative overflow-hidden cursor-pointer ${it.ratio} md:aspect-auto ${it.span}`}
          >
            <button
              data-testid={`lookbook-item-${i}`}
              onClick={() => openBooking()}
              className="absolute inset-0 w-full h-full text-left"
            >
              <img
                src={it.src}
                alt={it.caption}
                loading="lazy"
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-[800ms] ease-[cubic-bezier(0.25,1,0.5,1)] group-hover:scale-[1.03]"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-700" />
              <div className="absolute bottom-4 right-4 text-right translate-y-2 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-500">
                <p className="font-serif text-[#FDFBF7] text-lg md:text-xl font-light leading-tight">
                  {it.caption}
                </p>
                <p className="text-[#FDFBF7]/80 text-[10px] uppercase tracking-[0.2em] mt-1">
                  View Details
                </p>
              </div>
            </button>
          </Reveal>
        ))}
      </div>
    </section>
  );
};

export default Lookbook;
